<img
  [appStoryblok]="_editable"
  [height]="mode === 'fill' ? height : height"
  [width]="mode === 'fill' ? undefined : width"
  [class]="mode"
  class="d-lg-none mobile w-100 h-auto"
  [ngSrc]="image_mobile.filename"
  *ngIf="image_mobile?.filename"
  [fill]="mode === 'fill' ? true : false"
/>

<img
  [appStoryblok]="_editable"
  class="desktop d-lg-flex"
  [ngClass]="{ 'd-none ': image_mobile?.filename }"
  [height]="mode === 'fill' ? undefined : height"
  [width]="mode === 'fill' ? undefined : width"
  [class]="mode"
  [ngSrc]="image.filename"
  *ngIf="image?.filename"
  [fill]="mode === 'fill' ? true : false"
/>
